import React, {useContext} from "react";
import { Table, Tag, Popover, Space} from "antd";
import moment from "moment";
import { SearchOutlined } from "@ant-design/icons";
import { useListarSolicitudesAusencia } from "../../hooks";
import { SecurityContext } from "context/SecurityContextProvider";

// import MenuAcciones from "./MenuAcciones";
const ListaMovimientos = () => {
	const { getUsuarioAutenticado } = useContext(SecurityContext);
	const isSDF = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20330791684" ? true : false;
	const { solicitudesAusencia } = useListarSolicitudesAusencia();
	const isSDFEnergia = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20512436090" ? true : false;

	const columnas = [
		{
			title: (isSDF || isSDFEnergia) ? "Tipo Movimiento":"Tipo Ausencia",
			dataIndex: ["tipo", "descripcion"],
		},
		{
			title: "Fecha Inicio",
			dataIndex: "fechaInicioAusencia",
			//render: (text, fila) => moment(fila.fechaInicioAusencia).format("DD/MM/YYYY hh:mm a"),
			render: (text, fila) => moment(fila.fechaInicioAusencia).format("DD/MM/YYYY"),
		},
		{
			title: "Fecha Fin",
			dataIndex: "fechaFinAusencia",
			//render: (text, fila) => moment(fila.fechaFinAusencia).format("DD/MM/YYYY hh:mm a"),
			render: (text, fila) => moment(fila.fechaFinAusencia).format("DD/MM/YYYY"),
		},
		{
			title: "Dias",
			dataIndex: "diasSolicitados",
			align: "center",
		},
		{
			title: "Fecha de Solicitud",
			dataIndex: "fechaHoraSolicitud",
			render: (text, fila) => moment(fila.fechaHoraSolicitud).format("DD/MM/YYYY hh:mm a"),
		},
		// {
		// 	title: "Aprobador",
		// 	dataIndex: "aprobador",
		// 	render: (text, fila) =>
		// 		fila.requiereAprobacionJefeInmediato
		// 			? fila.jefeInmediato.nombreCompleto
		// 			: !fila.requiereAprobacionJefeInmediato &&
		// 			  fila.requiereAprobacionOtrosCargos &&
		// 			  fila.estado !== "PENDIENTE"
		// 			? fila.responsableOtrosCargos?.nombreCompleto
		// 				: fila.responsableAprobacionPrimerNivel
		// 			?fila.responsableAprobacionPrimerNivel?.nombreCompleto :"-",
		// },
		{
			title: "Colaborador",
			dataIndex: ["colaborador", "nombreCompleto"],
		},
		{
			title: "Estado",
			render: (text, fila) => <EtiquetaEstado fila={fila} />,
		},
		// {
		// 	title: "Acciones",
		// 	align: "center",
		// 	render: (text, fila) => <MenuAcciones solicitud={fila} />,
		// },
	];

	return (
		<Table
		rowKey={(value) => value.id}
		columns={columnas}
		dataSource={solicitudesAusencia}
			expandable={{
				expandedRowRender: (fila) => <Comentario registro={fila} />,
				rowExpandable: (fila) =>
				((isSDF || isSDFEnergia) && (
					(fila.comentario !== null && fila.comentario !== undefined && fila.comentario !== "")
					|| fila.informacionAdicional !== null)),
			}}
		/>
	);
};

const EtiquetaEstado = ({ fila }) => {
	const tagStyle = {
		borderRadius: "15px",
	};

	const color = getColor(fila.estado);

	if (fila.estado === "RECHAZADO") { 

		if (fila.jefeInmediato != null && fila.jefeInmediato.motivoRechazo != null) {
			const content = (
				<div style={{ width: 140 }}>
					<p>
						<strong>Motivo rechazo: </strong>
						{fila.jefeInmediato.motivoRechazo}
					</p>
				</div>
			);

			return (
				<div style={{ width: 140 }}>
					<Popover
						title={null}
						content={content}
						trigger="click"
						placement="bottomRight"
					// onOpenChange={onOpenChange}
					>
						<Space>
							<Tag color="red" className="milegajo-ant-tag" style={{ cursor: "pointer", ...tagStyle }}>
								<SearchOutlined /> RECHAZADO
							</Tag>
						</Space>
					</Popover>
				</div>
			);
		} else { 
			return (
				<Tag color={color} className="milegajo-ant-tag">
					{fila.estado}
				</Tag>
			);
		}
		
	}

	return (
		<Tag color={color} className="milegajo-ant-tag">
			{fila.estado}
		</Tag>
	);
};

const getColor = (estado) => {
	if (estado === "APROBADO") {
		return "green";
	} else if (estado === "RECHAZADO") {
		return "red";
	} else if (estado === "PENDIENTE") {
		return "gold";
	} else {
		return "magenta";
	}
};

const Comentario = ({ registro }) => {
	const { getUsuarioAutenticado } = useContext(SecurityContext);
	const isMaccaferriDePeru = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20418710757" ? true : false;
	const isMaccaferriConstruction = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20521749378" ? true : false;
	const isAceros = getUsuarioAutenticado().empresaSeleccionada.razonSocial.toUpperCase().includes("ACEROS CHILCA SAC")
		? true
		: false;
	const isSDF = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20330791684" ? true : false;
	const isSDFEnergia = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20512436090" ? true : false;

	return (
		<React.Fragment>
			{(isSDF || isSDFEnergia) && (
				<>
					{registro.informacionAdicional ? (
						<div style={{ marginLeft: 50 }}>
							{Object.entries(registro.informacionAdicional).map(([key, value], index) => (
								<p key={index}>
									<strong>{key.replace(/([A-Z])/g, " $1").toUpperCase()}: </strong>
									{typeof value === "boolean"
										? value
											? "Sí"
											: "No"
										: typeof value === 'string' && value.match(/^\d{4}-\d{2}-\d{2}T/) && moment(value).isValid()// Comprueba si es una fecha en formato ISO
										? moment(value).format("DD/MM/YYYY")
										: value}
								</p>
							))}
							<p>
								<strong>Comentario: </strong> {registro.comentario}
							</p>
						</div>
					) : (
						<p>
							<strong>Comentario: </strong> {registro.comentario}
						</p>
					)}
				</>
			)}
		</React.Fragment>
	);
};

export default ListaMovimientos;
